// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"135":"f57c27a7","282":"f57c27a7","375":"f57c27a7","905":"f57c27a7"}[chunkId] + ".chunk.css";
};